import utils from './utils';
export function getVideoTime(tem) {
    var max = parseInt(tem.video.duration);
    tem.currentTime.innerText = '00:00';
    tem.total.innerText = utils.secondToTime(max) || '00:00';
    if (isNaN(max)) {
        setTimeout(function () {
            getVideoTime(tem);
        }, 100);
    } else {
        return;
    }
}
export function resetVideoTime(tem) {
    tem.currentTime.innerText = '00:00';
    tem.total.innerText = '00:00';
}